import React from 'react';
import { Product } from '../../../data/models/product_list_response';
import { PurchaseOrder } from '../../../data/models/purchase_order_response';
import { ImageComponent } from '../common/image_component';
import { formatAmount, formatDate, getImageUrl } from '../../../utility/common';
import { useNavigate, useParams } from 'react-router';

export const PurchaseOrderTile = (props: { purchaseOrder: PurchaseOrder }) => {
  const { storeSlug } = useParams();
  const purchaseOrder = props.purchaseOrder;
  const orderTimeStamp = new Date(purchaseOrder?.orderTimestamp);

  const navigate = useNavigate();

  const navigateToDetailsPage = () => {
    navigate(`/${storeSlug}/orders/${props.purchaseOrder.purchaseOrderId}`);
  };

  return (
    <div className="flex flex-row px-6 py-6 border-b flex-wrap" onClick={navigateToDetailsPage}>
      <div className="flex flex-col text-left w-2/3">
        <div className="mb-2">{formatDate(orderTimeStamp)}</div>
        <div className="flex flex-row h-14 overflow-auto">
          {purchaseOrder?.products?.map((p: Product) => (
            <ImageComponent src={getImageUrl(p.productPictures)} key={'some-id'} htmlClass="h-14 w-14 mr-2" />
          ))}
        </div>
      </div>
      <div className="text-right justify-between w-1/3">
        <div className="text-primaryViolet text-right break-normal capitalize">
          {purchaseOrder.orderStatus.split('_').join(' ').toLowerCase()}
        </div>
        <div>{purchaseOrder.products.length} items</div>
        <div>{formatAmount(purchaseOrder.total)}</div>
      </div>
    </div>
  );
};
